// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--274sv","copyright":"footer-module--copyright--1OM7z","social":"footer-module--social--2YKKg"};